

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {TypeWebhook} from '@/model/resource/TypeWebhook'
import {TypeWebhookCollection} from '@/model/collection/TypeWebhookCollection'
import {ListTypeWebhookSchema} from '@/schema/resource/TypeWebhook/ListTypeWebhookSchema'
import {CsvTypeWebhookSchema} from '@/schema/resource/TypeWebhook/CsvTypeWebhookSchema'

@Component
export default class ListTypeWebhookView extends Mixins(MixinQueryRouter) {
  schema = new ListTypeWebhookSchema()
  collection = new TypeWebhookCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: TypeWebhook) {
    Helper.pushByName('editTypeWebhook', item.$id)
  }

  async removeItem(item: TypeWebhook) {
    await new DialogRemove(item).confirm(() => item.removeTypeWebhook())
    await this.collection.listTypeWebhook()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new TypeWebhookCollection().clearFilters().addFilter(params)

    await csv.listCsvTypeWebhook()
    new CsvTypeWebhookSchema().downloadCsv(csv.all())
  }
}
